import * as React from 'react'
import {BoxLink} from '../../common/router_links/BoxLink'
import {ProductLink} from '../../common/router_links/ProductLink'
import {Product} from '../../common/types/product'
import {BoxWithCompartmentProducts, createProductsInBoxes, ProductsInBoxesData} from '../../common/utils/createProductsInBoxes'
import {Box} from '../../webui/Box'
import {SortablePaginatedTable} from '../../webui/table/sortable-paginated-table/SortablePaginatedTable'
import {TableHeadCell} from '../../webui/table/sortable-paginated-table/TableHeadCell'
import {Comparator, getComparator} from '../../webui/table/sortable-paginated-table/utils'

interface Props {
  boxes: BoxWithCompartmentProducts[]
  products: Product[]
}

export interface ProductsInBoxesRow {
  id: string
  name: string
  count: number
  boxes: Array<{id: string; name: string}>
}

const productsInBoxesHeadCells: TableHeadCell<ProductsInBoxesRow>[] = [
  {
    id: 'name',
    label: 'Name',
    render: (value) => <ProductLink product={value} />,
  },
  {
    id: 'count',
    label: 'Count',
    render: (value) => value.count,
  },
  {
    id: 'boxes',
    label: 'Boxes',
    render: (value) => (
      <Box display={'flex'} flexDirection={'row'}>
        {value.boxes.map((box) => (
          <Box mr={1} key={box.id}>
            <BoxLink boxId={box.id} linkText={box.name} />
          </Box>
        ))}
      </Box>
    ),
  },
]

const INITIAL_ROWS_PER_PAGE = 20

const createRows = (data: ProductsInBoxesData): ProductsInBoxesRow[] => {
  return Object.entries(data).map(([productId, {product, boxes}]) => {
    return {
      id: productId,
      name: product.name,
      boxes,
      count: boxes.length,
    }
  })
}

const productsInBoxesComparator: Comparator<ProductsInBoxesRow> = (order, orderBy) => {
  return getComparator(order, orderBy)
}

export const ProductsInBoxes: React.FC<Props> = ({boxes, products}) => {
  const productsInBoxes = createProductsInBoxes(products, boxes)
  return (
    <SortablePaginatedTable
      getComparator={productsInBoxesComparator}
      title={'Products in boxes'}
      initialRowsPerPage={INITIAL_ROWS_PER_PAGE}
      initialOrderByKey={'name'}
      rows={createRows(productsInBoxes)}
      tableHeadCells={productsInBoxesHeadCells}
    />
  )
}
